import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../lib/utils';
import { SpecraLink } from '../ensigns/link';
import { SpecraText } from '../ensigns/typography';
/** A source the writer can draw from, with its kind and actions. */ export function SpecraSourceCard({ kind, title, description, meta, actions, href, renderLink, className, ...props }) {
    return /*#__PURE__*/ _jsxs("article", {
        className: cn('flex flex-col gap-[var(--space-1-5)] rounded-[var(--radius-md)] border border-[color:var(--border-control)] bg-[var(--surface-card)] p-[var(--space-2-5)]', className),
        ...props,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex",
                children: kind
            }),
            /*#__PURE__*/ _jsx(SpecraText, {
                as: "div",
                className: "font-medium",
                size: "body-sm",
                children: href ? /*#__PURE__*/ _jsx(SpecraLink, {
                    href: href,
                    renderLink: renderLink,
                    children: title
                }) : title
            }),
            description ? /*#__PURE__*/ _jsx(SpecraText, {
                as: "div",
                size: "body-ui",
                tone: "muted",
                children: description
            }) : null,
            meta ? /*#__PURE__*/ _jsx(SpecraText, {
                as: "div",
                size: "meta",
                tone: "muted",
                children: meta
            }) : null,
            actions ? /*#__PURE__*/ _jsx("div", {
                className: "flex flex-wrap gap-[var(--space-1-5)]",
                children: actions
            }) : null
        ]
    });
}
